import React from 'react';
import { useNavigate } from 'react-router';
import './Footer.css';
import Label from '../../common/type/Label';
import { useDispatch } from 'react-redux';
import { setSideNavItem } from '../../../redux/sidenavItems/actions';

const Footer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handlePrivacyPolicy = () => {
    dispatch(setSideNavItem('privacy'));
    navigate('/settings');
    window.scroll({
      top: 0, 
      left: 0, 
      behavior: 'smooth'
    });
  };

  const handleProfilePolicy = () => {
    dispatch(setSideNavItem('accounts'));
    navigate('/settings');
    window.scroll({
      top: 0, 
      left: 0, 
    });
  };
  return (
    <footer>
      <div className="links">
        <div className="link-group">
          <h4>
            <Label id="QuickLinks" />
          </h4>
          <a href="/">
            <Label id="HomeLink" />
          </a>
          <a href="/careteam">
            <Label id="careteam" />
          </a>
          <a
            href="https://dellchildrens.healthsparq.com/healthsparq/public/#/one/insurerCode=DCHP_I&brandCode=DCHP"
            target="_blank"
            rel="noreferrer"
          >
            <Label id="findDoctor" />
          </a>
          <a href="/idCards">
            <Label id="ManageIDCard" />
          </a>
          <a href="/benefits-overview">
            <Label id="reviewPlanCovereage" />
          </a>
        </div>

        <div className="link-group">
          <h4>
            <Label id="navBenefits" />
          </h4>
          <a href="/benefits-overview">
            <Label id="benefitsOverviewText" />
          </a>
          <a href="/benefits-whatscovered">
            <Label id="subnavWhatsCovered" />
          </a>
          <a href="/benefits-extrabenefits">
            <Label id="subnavExtraBenefits" />
          </a>
          <a href="/benefits-coveredmembers">
            <Label id="subnavCoveredMembers" />
          </a>
          <a href="/benefits-priorauthorizations">
            <Label id="subnavPriorAuthorizations" />
          </a>
        </div>

        <div className="link-group">
          <div className="no-link"></div>
          <a href="/idCards">
            <Label id="ManageIDCards" />
          </a>
          <a href="/claims">
            <Label id="claimsLink" />
          </a>
          <a
            href="https://dellchildrens.healthsparq.com/healthsparq/public/#/one/insurerCode=DCHP_I&brandCode=DCHP"
            target="_blank"
            rel="noreferrer"
          >
            <Label id="FindDoctorlink" />
          </a>
          <div onClick={handleProfilePolicy}>
            <Label id="profileSettings" />
          </div>
        </div>

        <div className="link-group">
          <h4>
            <Label id="getSupportlink" />
          </h4>
          <a href="tel:+1-855-921-6284">
            <Label id="contact" />
          </a>
          <a href="/securemessage">
            <Label id="SendASecureMessage" />
          </a>
        </div>
      </div>
      <div className="link-group" id="terms-group">
        <div
       
          onClick={handlePrivacyPolicy}
          className="privacy-policy-link"
        >
          <Label id="footerPrivacy" />
        </div>
        <a href="/termsOfUse"><Label id='footerTerms' /></a>
      </div>
      <div className="link-group termlinks">
        <div className="term-group">
          <span className="footer-ms"><Label id='footerText' /></span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
